import { Avatar, Box, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, IconButton, InputLabel, Pagination, Paper, styled, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import { useEventsHistoryMutation, useSelectProfileMutation, useViewAllCandidateForJobMutation, useViewAllCandidateMutation } from "../../redux/jobpostings/jobpostings.api"
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import MUIButton from "../../reusable_components/components/MUIButton";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { TableLoader } from "../../reusable_components/components/TableLoader";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import contractor from '../../assets/agreement.png';

const AddProfile = () => {
    const commonFilter = JSON.parse(localStorage.getItem('commonsearchfilter'))
    const [searchAddress, setSearchAddress] = useState(commonFilter?.addProfile?.address || "")
    const [searchTechnology, setSearchTechnology] = useState(commonFilter?.addProfile?.technologies || "")
    const [searchPhone, setSearchPhone] = useState(commonFilter?.addProfile?.mobileOrAlternateMobile || "")
    const [searchEmail, setSearchEmail] = useState(commonFilter?.addProfile?.emailOrAlternateEmail || "")
    const [searchFirstName, setSearchFirstName] = useState(commonFilter?.addProfile?.firstNameOrLastName || "")

    const location = useLocation()
    const navigate = useNavigate()
    const { positionId, clientName, positionTitle, candidateTable } = location?.state || ""
    const { id, name, title } = location?.state || ""

    const { Profile } = useSelector((state) => state.common)
    const { Snackbar } = useContext(SnackbarContext)

    const [page, setPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [totalDataCount, setTotalDataCount] = useState(0)
    const [keywords, setKeywords] = useState(localStorage.getItem('addProfileSearch') || "")
    const [tableDats, setTableDatas] = useState([])
    const [open, setOpen] = useState(false)
    const [historyTableDatas, setHistoryTableDatas] = useState([])
    const [profileId, setProfileId] = useState("")
    const [profileIdArr, setProfileIdArr] = useState([])
    const [sortingColumn, setSortingColumn] = useState("first_name")
    const [sortingDirection, setSortingDirection] = useState("ASC")
    const [triggerApi, setTriggerApi] = useState(false)
    const [showTableLoader, setShowTableLoader] = useState(false)
    const [showClearFilter, setShowClearFilter] = useState(false)
    const [shouldFetch, setShouldFetch] = useState(false);


    const handleOpen = (item) => {
        setOpen(true)
        setProfileId(item?.profileId)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const [filterOpen, setFilterOpen] = useState(false)

    const handleMoreFilterOpen = () => {
        if (chips.length === 0) {
            setSearchPhone("")
            setSearchTechnology("")
            setSearchEmail("")
            setSearchAddress("")
            setSearchFirstName("")
            setFilterOpen(true)
        } else {
            setFilterOpen(true)
        }
    }

    const handleClearFilter = () => {
        setSearchPhone("")
        setSearchTechnology("")
        setSearchEmail("")
        setSearchAddress("")
        setSearchFirstName("")
        setShowClearFilter(false)
        localStorage.setItem('commonsearchfilter', JSON.stringify({ ...commonFilter, addProfile: {} }))
    }

    const handleMoreFilterClose = () => {
        setFilterOpen(false)
        const hasValue = chips?.some((item) => item?.label)
        if (!hasValue) {
            setSearchPhone("")
            setSearchTechnology("")
            setSearchEmail("")
            setSearchAddress("")
            setSearchFirstName("")
            setShowClearFilter(false)
            localStorage.setItem('commonsearchfilter', JSON.stringify({ ...commonFilter, addProfile: {} }))
        }
    }

    useEffect(() => {
        const addProfile = commonFilter?.addProfile
        const hasValue = addProfile && Object.values(addProfile)?.some(value =>
            value !== 0 && value !== null && value !== undefined && value !== ''
        )

        if (hasValue) {
            setShouldFetch(true)
        }

    }, [])

    const [viewAllCandidateForJob] = useViewAllCandidateForJobMutation()
    const [eventsHistory] = useEventsHistoryMutation()
    const [selectProfile] = useSelectProfileMutation()

    const params = useParams()
    const Id = params?.id

    const getTableDatas = async () => {
        try {
            const payload = {
                page: page - 1,
                size: rowsPerPage,
                positionId: Id,
                address: searchAddress,
                technologies: searchTechnology,
                mobileOrAlternateMobile: searchPhone,
                emailOrAlternateEmail: searchEmail,
                firstNameOrLastName: keywords ? keywords : searchFirstName || "",
            }

            setShowTableLoader(true)
            const response = await viewAllCandidateForJob(payload).unwrap()
            setShowTableLoader(false)
            if (response) {
                const datas = response?.response ? response?.response?.data : []
                setTableDatas(datas)
                setTotalDataCount(response?.response?.Count)
            }
        } catch (err) {
            Snackbar("Network error", 'error')
            setShowTableLoader(false)
        }
    }

    const [chips, setChips] = useState([])

    const letsFilterDatas = () => {

        const updateChips = ([
            {
                label: searchFirstName,
                onDelete: () => {
                    setSearchFirstName('')
                    localStorage.setItem('commonsearchfilter',
                        JSON.stringify({
                            ...commonFilter,
                            addProfile: {
                                ...commonFilter.addProfile,
                                firstNameOrLastName: ""
                            }
                        })
                    )
                    setTriggerApi(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== searchFirstName))
                }
            },
            {
                label: searchPhone,
                onDelete: () => {
                    setSearchPhone('')
                    localStorage.setItem('commonsearchfilter',
                        JSON.stringify({
                            ...commonFilter,
                            addProfile: {
                                ...commonFilter.addProfile,
                                mobileOrAlternateMobile: ""
                            }
                        })
                    )
                    setTriggerApi(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== searchPhone))
                }
            },
            {
                label: searchTechnology,
                onDelete: () => {
                    setSearchTechnology('')
                    localStorage.setItem('commonsearchfilter',
                        JSON.stringify({
                            ...commonFilter,
                            addProfile: {
                                ...commonFilter.addProfile,
                                technologies: ""
                            }
                        })
                    )
                    setTriggerApi(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== searchTechnology))
                }
            },
            {
                label: searchEmail,
                onDelete: () => {
                    setSearchEmail('')
                    localStorage.setItem('commonsearchfilter',
                        JSON.stringify({
                            ...commonFilter,
                            addProfile: {
                                ...commonFilter.addProfile,
                                emailOrAlternateEmail: ""
                            }
                        })
                    )
                    setTriggerApi(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== searchEmail))
                }
            },
            {
                label: searchAddress,
                onDelete: () => {
                    setSearchAddress('')
                    localStorage.setItem(
                        'commonsearchfilter', JSON.stringify({
                            ...commonFilter,
                            addProfile: {
                                ...commonFilter.addProfile,
                                address: ""
                            }
                        })
                    )
                    setTriggerApi(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== searchAddress))
                }
            }
        ]).filter(Boolean)

        setChips(updateChips)
        setTriggerApi(true)
        setShowClearFilter(true)
    }

    useEffect(() => {
        getTableDatas()
    }, [keywords, triggerApi, showClearFilter])

    useEffect(() => {
        if (triggerApi) {
            getTableDatas()
            handleMoreFilterClose()
            setTriggerApi(false)
        }
    }, [viewAllCandidateForJob, keywords, page, rowsPerPage, sortingDirection, searchPhone, searchTechnology, searchEmail, searchAddress, searchFirstName, triggerApi])

    useEffect(() => {
        const getHistoryTable = async () => {
            try {
                const payload = {
                    page: 0,
                    size: 5000,
                    profileId: profileId,
                    positionId: positionId ? positionId : id
                }
                if (open) {
                    const response = await eventsHistory(payload).unwrap()
                    setHistoryTableDatas(response?.response?.eventHistory)
                }
            } catch (err) {
                Snackbar("Network error", 'error')
            }
        }
        getHistoryTable()
    }, [open])

    const handlePageChange = (e, newPage) => {
        setPage(newPage)
        setTriggerApi(true)
    }

    const handleRowsPerPageChange = (e) => {
        setRowsPerPage(parseInt(e.target.value, 10))
        setPage(0)
    }

    const handleKeywordChange = (e) => {
        const value = e.target.value
        localStorage.setItem('addProfileSearch', value)
        setPage(1)
        setKeywords(value)
    }

    const handleProfileCheckbox = (profileId, isAlreadyChecked) => {
        setProfileIdArr(prev =>
            isAlreadyChecked
                ? prev.filter(id => id !== profileId)  // Remove if already checked
                : [...prev, profileId]                 // Add if not checked
        );
    };

    const allChecked = tableDats?.filter((item) => item?.profileIdIsJoined === "N").map((data) => data?.profileId)

    const handleSelectAllTableData = (event) => {
        if (event.target.checked) {
            const allChecked = tableDats?.filter((item) => item?.profileIdIsJoined === "N").map((data) => data?.profileId)
            setProfileIdArr(allChecked);
        } else {
            setProfileIdArr([]);
        }
    };

    const handleSearchFirstName = (e) => {
        const value = e.target.value
        setSearchFirstName(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {}

        const updatedFilter = {
            ...currentFilter,
            addProfile: {
                ...currentFilter.addProfile,
                firstNameOrLastName: value
            }
        }

        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter))
    }

    const handleSearchPhoneChange = (e) => {
        const value = e.target.value
        setSearchPhone(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {}

        const updatedFilter = {
            ...currentFilter,
            addProfile: {
                ...currentFilter.addProfile,
                mobileOrAlternateMobile: value
            }
        }

        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter))
    }

    const handleSearchTechChange = (e) => {
        const value = e.target.value
        setSearchTechnology(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {}

        const updatedFilter = {
            ...currentFilter,
            addProfile: {
                ...currentFilter.addProfile,
                technologies: value
            }
        }

        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter))


    }

    const handleSearchEmailChange = (e) => {
        const value = e.target.value
        setSearchEmail(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {}

        const updatedFilter = {
            ...currentFilter,
            addProfile: {
                ...currentFilter.addProfile,
                emailOrAlternateEmail: value
            }
        }

        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter))
    }

    const handleSearchAddressChange = (e) => {
        const value = e.target.value
        setSearchAddress(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {}

        const updatedFilter = {
            ...currentFilter,
            addProfile: {
                ...currentFilter.addProfile,
                address: value
            }
        }

        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter))
    }

    const handleSort = (columnName) => {
        if (sortingColumn === columnName) {
            setSortingDirection((prev) => (prev === 'ASC' ? 'DESC' : 'ASC'))
            setTriggerApi(true)
        } else {
            setSortingColumn(columnName)
            setSortingDirection('ASC')
        }
    }

    const handleViewJobNav = () => {
        // if (candidateTable === true) {
        //     navigate('/jobpost')
        // } else {
        //     navigate(`/submitprofiles/${positionId ? positionId : id}`, {
        //         state: { positionTitle: positionTitle ? positionTitle : title }
        //     })
        // }
        navigate(-1)
    }

    const handleProfileSubmission = async () => {
        // localStorage.setItem("ViewTab","2")
        try {
            const payload = {
                jobPostId: positionId ? positionId : id,
                logInId: Profile?.profile?.emailId,
                profile: profileIdArr
            }

            const response = await selectProfile(payload).unwrap()

            if (response?.status === 200) {
                Snackbar('Profiles Assigned Successfully', 'success')
                navigate(`/submitprofiles/${positionId ? positionId : id}`, {
                    state: { positionTitle: positionTitle ? positionTitle : title, activeTab: "2", findProfile: true }
                })
            } else {
                Snackbar('failed to assign the profile', 'error')
            }
        } catch (err) {
            Snackbar('Network error', 'error')
        }
    }

    const filteredTableDatas = tableDats?.filter((name) => {
        return (
            (name?.firstName?.toLowerCase()?.startsWith(keywords?.toLowerCase())) ||
            (name?.lastName?.toLowerCase()?.startsWith(keywords?.toLowerCase()))
        )
    })

    useEffect(() => {
        if (chips?.every((name) => !name?.label)) {
            setShowClearFilter(false)
        }
    }, [triggerApi])

    useEffect(() => {
        if (shouldFetch) {
            letsFilterDatas();
            setShouldFetch(false)
        }
    }, [page, shouldFetch]);

    const handleBackNavigation = () => {
        // if (candidateTable === true) {
        //     navigate('/jobpost')
        // }
        navigate(-1)
        localStorage.setItem('commonsearchfilter', JSON.stringify({ ...commonFilter, addProfile: {} }))
    }


    return (
        <Box className='container'>
            <Grid2 item sx={{ display: 'flex', alignItems: 'center', color: '#6941C6', gap: '4px', cursor: 'pointer', width: '40px', marginBottom: '10px' }} onClick={handleBackNavigation}>
                <ArrowBackIcon sx={{ fontSize: '17px' }} />
                <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Back</Typography>
            </Grid2>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography className="title">Assign Candidates</Typography>
                <Grid2 item sx={{ width: '24%' }}>
                    <TextField
                        className="textfields"
                        size="small"
                        placeholder="Search"
                        value={keywords}
                        onChange={handleKeywordChange}
                        slotProps={{
                            input: {
                                startAdornment: <SearchIcon position="start" sx={{ color: '#717680' }} />
                            }
                        }}
                    />
                </Grid2>
            </Box>

            <Grid2 item>
                <Dialog
                    open={filterOpen}
                    scroll="paper"
                    maxWidth='md'
                    className="sidePopup"
                >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '18px', fontWeight: 600 }}>
                        Filters
                        <CloseIcon sx={{ color: '#717680', cursor: 'pointer' }} onClick={handleMoreFilterClose} />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '100%' }} gap={2}>
                                <Grid2 item>
                                    <InputLabel className="inputlabels">Name</InputLabel>
                                    <TextField
                                        className="textfields"
                                        placeholder="Search Name"
                                        value={searchFirstName}
                                        onChange={handleSearchFirstName}
                                    />
                                </Grid2>

                                <Grid2 item>
                                    <InputLabel className="inputlabels">Phone</InputLabel>
                                    <TextField
                                        className="textfields"
                                        placeholder="Search Phone Number"
                                        value={searchPhone}
                                        onChange={handleSearchPhoneChange}
                                    />
                                </Grid2>

                                <Grid2 item>
                                    <InputLabel className="inputlabels">Technology</InputLabel>
                                    <TextField
                                        className="textfields"
                                        placeholder="Search Technologies"
                                        value={searchTechnology}
                                        onChange={handleSearchTechChange}
                                    />
                                </Grid2>
                            </Grid2>
                            <Grid2 item sx={{ marginTop: '15px' }}>
                                <InputLabel className="inputlabels">Email</InputLabel>
                                <TextField
                                    className="textfields"
                                    placeholder="Search Email"
                                    value={searchEmail}
                                    onChange={handleSearchEmailChange}
                                />
                            </Grid2>

                            <Grid2 item sx={{ marginTop: '15px' }}>
                                <InputLabel className="inputlabels">Address</InputLabel>
                                <TextField
                                    className="textfields"
                                    placeholder="Search Address"
                                    value={searchAddress}
                                    onChange={handleSearchAddressChange}
                                />
                            </Grid2>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Grid2 item sx={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                            <MUICancelButton title='Cancel' sx={{ borderColor: '#D6BBFB', width: '42%' }} onClick={handleMoreFilterClose} />
                            <MUIButton title='Apply' sx={{ width: '42%' }}
                                onClick={() => {
                                    setPage(1)
                                    setShouldFetch(true)
                                }}
                            />
                        </Grid2>
                    </DialogActions>
                </Dialog>
            </Grid2>

            <Grid2 container sx={{ marginTop: '25px' }}>
                <Paper sx={{ width: '100%', overflow: 'auto', border: '1px solid #E9EAEB' }} elevation={0}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={100}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div>
                                            <Typography sx={{ color: '#181D27', fontWeight: 600, fontSize: '16px' }}>{positionTitle ? positionTitle : title}</Typography>
                                            <Typography sx={{ color: '#535862', fontWeight: 400, fontSize: '14px' }}>{positionId ? positionId : id} {clientName ? clientName : name}</Typography>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                {showClearFilter && (
                                                    chips?.map((item, index) => {
                                                        return (
                                                            item?.label && (
                                                                <Chip
                                                                    className="Assign-candidatechip"
                                                                    key={index}
                                                                    label={item?.label}
                                                                    deleteIcon={<CloseIcon sx={{ color: '#414651 !important' }} />}
                                                                    variant="outlined"
                                                                    size='small'
                                                                    onDelete={item?.onDelete}
                                                                />
                                                            )
                                                        )
                                                    })
                                                )}
                                            </div>
                                        </div>

                                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '14px' }}>
                                            <MUICancelButton title='More Filters' onClick={handleMoreFilterOpen} startIcon={<FilterListIcon sx={{ fontSize: '20px !important' }} />} sx={{ color: '#6941C6', borderColor: '#D6BBFB', fontWeight: 600, width: '130px' }} />
                                            {(searchFirstName || searchPhone || searchTechnology || searchEmail || searchAddress) && showClearFilter && (
                                                <MUICancelButton title='Clear Filter' sx={{ width: '100px' }} onClick={handleClearFilter} />
                                            )}
                                        </div>
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="tableHeadersCell" sx={{ display: 'flex' }}>
                                    <Checkbox
                                        sx={{
                                            '& .MuiSvgIcon-root': { fontSize: 18 },
                                            "&.Mui-checked": {
                                                color: '#7F56D9'
                                            }
                                        }}
                                        checked={profileIdArr?.length === allChecked?.length && tableDats?.length > 0}
                                        onChange={handleSelectAllTableData}
                                    />
                                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                        onClick={() => handleSort("first_name")}
                                    >
                                        Name
                                        <UnfoldMoreIcon sx={{ fontSize: '17px' }} />
                                    </div>
                                </TableCell>
                                <TableCell className="tableHeadersCell">Position</TableCell>
                                <TableCell className="tableHeadersCell"> Technologies </TableCell>
                                <TableCell className="tableHeadersCell"> Address </TableCell>
                                {/* <TableCell className="tableHeadersCell">Is Refferal</TableCell> */}
                                <TableCell className="tableHeadersCell">Sourced By</TableCell>
                                <TableCell className="tableHeadersCell">Candidate Status</TableCell>
                                <TableCell className="tableHeadersCell"> Action </TableCell>
                            </TableRow>
                        </TableHead>

                        {!showTableLoader ? (
                            filteredTableDatas?.length > 0 ? (
                                <TableBody>
                                    {filteredTableDatas?.map((item, index) => {
                                        const firstLetter = item?.firstName
                                        const letter = firstLetter?.charAt(0)?.toUpperCase()
                                        const sourceName = item?.sourceEmail?.charAt(0)?.toUpperCase()
                                        const colors = ['green', "darkorange", 'purple', "#3357FF", 'orangered', "darkgreen", 'pink']
                                        const backgroundColor = colors[index % colors?.length]
                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                    '&:hover': { backgroundColor: '#f1f1f1' },
                                                }}
                                            >
                                                <TableCell className="tableBodyCell" sx={{ width: '27%' }}>
                                                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                        {/* Left side: checkbox + avatar */}
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: '10px' }}>
                                                            <Checkbox
                                                                checked={item?.hasSelected || profileIdArr.includes(item?.profileId)}
                                                                onChange={() =>
                                                                    handleProfileCheckbox(
                                                                        item?.profileId,
                                                                        item?.hasSelected || profileIdArr.includes(item?.profileId)
                                                                    )
                                                                }
                                                                sx={{
                                                                    '& .MuiSvgIcon-root': { fontSize: 18 },
                                                                    "&.Mui-checked": {
                                                                        color: '#7F56D9',
                                                                    },
                                                                }}
                                                            />
                                                            <Avatar
                                                                sx={{
                                                                    backgroundColor: backgroundColor,
                                                                    width: 30,
                                                                    height: 30,
                                                                    fontSize: '14px',
                                                                }}
                                                            >
                                                                {letter}
                                                            </Avatar>
                                                        </div>

                                                        {/* Right side: name + type + email + mobile */}
                                                        <div>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}
                                                                onClick={() => navigate(`/editcandidateprofile/${item?.profileId}`)}
                                                            >
                                                                <span style={{ color: '#7F56D9', fontWeight: 600 }}>
                                                                    {item?.firstName} {item?.lastName}
                                                                </span>

                                                                <Tooltip
                                                                    placement="top"
                                                                    title={
                                                                        item?.candidateType === "P"
                                                                            ? ""
                                                                            : "Contract Candidate"
                                                                    }
                                                                    slotProps={{
                                                                        tooltip: {
                                                                            sx: {
                                                                                backgroundColor: "#0A0D12",
                                                                                borderRadius: '8px',
                                                                                padding: '8px 12px',
                                                                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                            }
                                                                        }
                                                                    }}
                                                                >
                                                                    {item?.candidateType === "P" ? (
                                                                        ""
                                                                    ) : (
                                                                        <img
                                                                            src={contractor}
                                                                            alt="contractor"
                                                                            width={22}
                                                                            height={22}
                                                                            style={{ display: 'inline-block', verticalAlign: 'middle' }}
                                                                        />
                                                                    )}
                                                                </Tooltip>
                                                            </div>

                                                            {/* Email + Mobile below */}
                                                            <p style={{ color: '#52525B', margin: 0 }}>
                                                                {item?.email} <br />
                                                                {item?.mobile}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </TableCell>

                                                <TableCell className="tableBodyCell" sx={{ color: '#181D27' }}>{item.referralPosition || "NA"}</TableCell>
                                                <TableCell className="tableBodyCell" sx={{ color: '#414651' }}>
                                                    {item?.technologies?.map((item) => (
                                                        `${item?.itemName}`
                                                    ))?.join(', ')}
                                                </TableCell>
                                                <TableCell className="tableBodyCell" sx={{ color: '#181D27' }}>{item?.address || 'NA'}</TableCell>
                                                {/* <TableCell className="tableBodyCell" sx={{ color: '#181D27' }}><p>{item?.isReferral === 'Y' ? 'Yes' : 'No'}</p></TableCell> */}
                                                <TableCell className="tableBodyCell" >
                                                    <Box sx={{ color: '#181D27', width: '27%', display: 'flex', flexDirection: 'row' }}>
                                                        <Avatar sx={{ backgroundColor: backgroundColor, marginRight: '10px', width: 30, height: 30, fontSize: '14px' }}>{sourceName}</Avatar>
                                                        <div>
                                                            <p style={{ color: '#52525B' }}>{item?.sourceName} <br></br> {item?.sourceEmail}</p>
                                                        </div>
                                                    </Box>
                                                </TableCell>
                                                <TableCell className="tableBodyCell" sx={{ color: '#181D27' }}>{item?.candidateStatus === "ELC" ? "Employee Looking for Change" : item?.candidateStatus === "ENO" ? "Employee Not Open" :
                                                    item?.candidateStatus === "EOB" ? "Employee On Bench" : item?.candidateStatus === "UEM" ? "Unemployed" : item?.candidateStatus === "EAV" ? "Employee Available" : "NA"}</TableCell>
                                                <TableCell className="tableBodyCell">
                                                    <Tooltip title="View History"
                                                        slotProps={{
                                                            tooltip: {
                                                                sx: {
                                                                    backgroundColor: "#0A0D12",
                                                                    borderRadius: '8px',
                                                                    padding: '8px 12px',
                                                                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                }
                                                            }
                                                        }}>
                                                        <VisibilityOutlinedIcon className="icons" sx={{ cursor: "pointer" }} onClick={() => handleOpen(item)} />
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            ) : (
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={8}>
                                            <Typography className="emptydatas">No Data Found</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )
                        ) : (
                            <TableRow>
                                <TableCell colSpan={8}>
                                    <Box className='tableloader'>
                                        <TableLoader />
                                    </Box>
                                </TableCell>
                            </TableRow>
                        )}
                        {Math.ceil(totalDataCount / rowsPerPage) > 1 && (
                            <TableRow>
                                <TableCell colSpan={100}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <MUICancelButton
                                            title='Previous'
                                            onClick={() => handlePageChange(null, page - 1)}
                                            startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                            disabled={page === 1}
                                            sx={{ height: '36px' }}
                                        />

                                        <Pagination
                                            page={page}
                                            onChange={handlePageChange}
                                            count={Math.ceil(totalDataCount / rowsPerPage)}
                                            siblingCount={1}
                                            boundaryCount={1}
                                            shape="rounded"
                                            hidePrevButton
                                            hideNextButton
                                        />

                                        <MUICancelButton
                                            title='Next'
                                            startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(totalDataCount / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                            onClick={() => handlePageChange(null, page + 1)}
                                            disabled={page === Math.ceil(totalDataCount / rowsPerPage)}
                                            sx={{ height: '36px' }}
                                        />

                                    </div>
                                </TableCell>
                            </TableRow>
                        )}
                    </Table>
                </Paper>

                {/* <Table>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                className="tablepagination"
                                onPageChange={handlePageChange}
                                page={page}
                                onRowsPerPageChange={handleRowsPerPageChange}
                                rowsPerPage={rowsPerPage}
                                rowsPerPageOptions={[10, 20, 50]}
                                count={totalDataCount || 0}
                            />
                        </TableRow>
                    </TableFooter>
                </Table> */}
            </Grid2>

            <Dialog
                open={open}
                onClose={handleClose}
                scroll="paper"
                maxWidth="md"
                sx={{
                    '& .MuiDialog-paper': {
                        minHeight: '85vh',
                        minWidth: '70vw'
                    },
                    marginLeft: '70px'
                }}
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '18px', fontWeight: 600 }}>
                    History
                    <CloseIcon sx={{ color: '#52525B', cursor: 'pointer' }} onClick={handleClose} />
                </DialogTitle>
                <DialogContent dividers>
                    <DialogContentText>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className="tableHeadersCell">Date</TableCell>
                                    <TableCell className="tableHeadersCell">Client Name</TableCell>
                                    <TableCell className="tableHeadersCell">Job Title</TableCell>
                                    <TableCell className="tableHeadersCell">Event</TableCell>
                                    <TableCell className="tableHeadersCell">Notes</TableCell>
                                    <TableCell className="tableHeadersCell">Processed By</TableCell>
                                </TableRow>
                            </TableHead>
                            {historyTableDatas?.length > 0 ? (
                                <TableBody>
                                    {historyTableDatas?.map((item, index) => (
                                        <TableRow
                                            key={index}
                                            sx={{
                                                backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                '&:hover': { backgroundColor: '#f1f1f1' },
                                            }}
                                        >
                                            <TableCell className="tableBodyCell">
                                                {item?.date ? dayjs(item?.date).format('DD-MM-YYYY hh:mm:ss A') : 'N/A'}
                                            </TableCell>
                                            <TableCell className="tableBodyCell">{item?.clientName}</TableCell>
                                            <TableCell className="tableBodyCell">{item?.jobTitile}</TableCell>
                                            <TableCell className="tableBodyCell">{item?.event}</TableCell>
                                            <TableCell className="tableBodyCell">{item?.notes ? item?.notes : 'N/A'}</TableCell>
                                            <TableCell className="tableBodyCell">{item?.processedBy}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            ) : (
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={6}>
                                            <Typography className="emptydatas">No Data Found</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )}
                        </Table>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MUICancelButton onClick={handleClose} title="Close" />
                </DialogActions>
            </Dialog>

            <Grid2 item sx={{ display: 'flex', justifyContent: 'flex-end', gap: '20px', marginTop: '15px' }}>
                <MUICancelButton title='Cancel' onClick={handleViewJobNav} />
                <MUIButton title='Add Profiles' onClick={handleProfileSubmission} sx={{ backgroundColor: '#7F56D9', borderRadius: '7px', width: '120px' }} disabled={profileIdArr.length === 0} />
            </Grid2>
        </Box>
    )
}

export default AddProfile